// extracted by mini-css-extract-plugin
export var bodySections = "_8f-8";
export var gray = "_8f-7";
export var green = "_8f-4";
export var iconContainer = "_8f-9";
export var iconWidgetContainer = "_8f-1";
export var phoneIcon = "_8f-2";
export var red = "_8f-5";
export var statusDot = "_8f-3";
export var widgetContainer = "_8f-0";
export var yellow = "_8f-6";